<template>
  <div>
    <template v-if="isLoading || value === undefined">
      <span class="icon">
        <i class="fas fa-spinner fa-pulse"></i>
      </span>
    </template>
    <template v-else-if="isEditting">
      <div class="field is-grouped">
        <div class="control has-icons-left">
          <input type="date"
              class="input"
              v-bind:value="date"
              v-on:input="updateDate"
              :disabled="isSaving"
              :class="isInvalidInternal ? 'is-danger' : ''">
          <span class="icon is-small is-left">
            <i class="fas fa-calendar"></i>
          </span>
        </div>
        <div class="control has-icons-left">
          <input type="time"
              class="input"
              v-bind:value="time"
              v-on:input="updateTime"
              :disabled="isSaving"
              :class="isInvalidInternal ? 'is-danger' : ''">
          <span class="icon is-small is-left">
            <i class="fas fa-clock"></i>
          </span>
        </div>
      </div>
    </template>
    <template v-else>
      <slot>{{value}}</slot>
    </template>
  </div>
</template>
<script>
export default {
  name: 'EditableInput',
  props: ['value' ,'isLoading', 'isEditting', 'isSaving', 'isInvalid'],
  methods: {
    updateDate(event) {
      const newDate = new Date(`${event.target.value} ${this.time}`);
      this.$emit('input', newDate).toISOString();
    },
    updateTime(event) {
      const newDate = new Date(`${this.date} ${event.target.value}`);
      this.$emit('input', newDate).toISOString();
    },
    getLocalDate() {
      const date = new Date(this.value);
      return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    },
  },
  computed: {
    isInvalidInternal() {
      return this.isInvalid || !this.value;
    },
    date() {
      return this.getLocalDate().toISOString().split('T')[0];
    },
    time() {
      return this.getLocalDate().toISOString().split('T')[1].split(':', 2).join(':');
    },
  },
}
</script>